import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RTL_LANGS = new Set(['ar', 'he', 'fa', 'ur']);

/** Sync <html lang> and <html dir> with i18next. WCAG 3.1.1 / 3.1.2. */
export const useDocumentLang = (): void => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const apply = (lng: string) => {
      const base = (lng || 'en').split('-')[0];
      document.documentElement.lang = base;
      document.documentElement.dir = RTL_LANGS.has(base) ? 'rtl' : 'ltr';
    };
    apply(i18n.language);
    i18n.on('languageChanged', apply);
    return () => {
      i18n.off('languageChanged', apply);
    };
  }, [i18n]);
};
